const FieldListComponent = {
    templateUrl: '/formViewer/component/fieldList/fieldList.tpl.html',
    controller: 'fieldListController',
    bindings: {
        row: '<',
        hideLabel: '<?',
        collapsible: '@'
    }
};

angular.module('umFormViewer')
    .component('uiFieldList', FieldListComponent);
